<template>
    <span class="required-field no-tooltip-icon" title="Required">*</span>
</template>





<script>
export default {

}
</script>





<style lang="scss" scoped>
    .required-field
    {
        color:red;
        display: inline-block;
        margin-left: 5px;
    }
</style>